import { render, staticRenderFns } from "./ConfigOwner.vue?vue&type=template&id=614799c7"
import script from "./ConfigOwner.vue?vue&type=script&lang=js"
export * from "./ConfigOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports